import React from 'react';
import intl from 'react-intl-universal';

import { getTimeByUtcOffset } from '@/utils/intl';
import { DATE_TIME_FORMAT } from '@/config';
import { parseFen2Currency } from '@/utils/number';

import { PAY_TYPE_CODE_MAP } from '@/config/constant';
import commonStyles from '../common.module.scss';
import styles from './index.module.scss';

const Info = ({ info }) => {
  return (
    <dl className={`${commonStyles['bill-block']} ${styles['crossRefund-bill-info']}`}>
      <dt className={commonStyles['bill-block-title']}>
        {intl.get('bill_cross_refound_pay_info')}
      </dt>
      <dd>
        <label className="text-colon">{intl.get('bill_refound_res_bill_subject')}</label>
        <span>{info?.subjectCodeName || '-'}</span>
      </dd>
      <dd>
        <label className="text-colon">{intl.get('bill_credit_amount')}</label>
        <span>{parseFen2Currency(info?.amount)}</span>
      </dd>
      <dd>
        <label className="text-colon">{intl.get('bill_refound_res_pay_channel')}</label>
        <span>{PAY_TYPE_CODE_MAP[info?.paymentType] || '-'}</span>
      </dd>
      <dd>
        <label className="text-colon">{intl.get('bill_refound_res_detail')}</label>
        <span className={styles['crossRefund-detail']}>{info?.detail || '-'}</span>
      </dd>
      <dd>
        <label className="text-colon">{intl.get('bill_refound_res_pay_time')}</label>
        <span>{getTimeByUtcOffset(info?.createTime, DATE_TIME_FORMAT) || '-'}</span>
      </dd>
    </dl>
  );
};

export default Info;
